<template>
	<app>
		<c-form ref="form">
			<c-form>
				<c-form-item type="hidden" name="kgl_id"></c-form-item>
				<c-form-item v-model="currentProjectId" type="select" label="项目名称" name="project_id" :options="projectList" required :disabled="!!id"></c-form-item>
				<c-form-item type="input" label="业主单位" name="yzdw_name" required disabled></c-form-item>
				<c-form-item type="input" label="监理单位" name="jldw_name" required disabled></c-form-item>
				<c-form-item type="input" label="企业名称" name="zbqy_name" required disabled></c-form-item>
				<c-form-item type="input" label="施工建设地址" name="xm_address" required disabled></c-form-item>
				<c-form-item type="input" label="备注说明" name="remark"></c-form-item>
			</c-form>
			
			<c-title>其他资料上传</c-title>
			<c-form>
				<c-form-item type="image" label="营业执照" name="yyzz_path" required></c-form-item>
				<c-form-item type="image" label="资质证书" name="zzzs_path" required></c-form-item>
				<c-form-item type="image" label="法人身份证头像面" name="frsfztx_path" required></c-form-item>
				<c-form-item type="image" label="法人身份证国徽面" name="frsfzgh_path" required></c-form-item>
				<c-form-item type="file" label="施工方案" name="sgfa_path" required file-type="word,excel,pdf,zip,image"></c-form-item>
				<c-form-item type="file" label="其它文件" name="other_path" file-type="word,excel,pdf,zip,image"></c-form-item>
			</c-form>
		</c-form>
		
		<div slot="button">
			<c-button size="m" @click="submitHandle">提交申请</c-button>
		</div>
	</app>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		props: {
			id: String
		},
		
		data() {
			return {
				projectList: [],
				currentProjectId: '',
				insuranceList: []
			}
		},
		
		computed: {
			...mapState(['userInfo'])
		},
		
		watch: {
			currentProjectId(val) {
				if (val) {
					this.request({
						url: '/project/detail',
						data: {
							project_id: val
						},
						success: data => {
							this.$refs.form.set({
								yzdw_name: data.project_info.yzdw_name,
								jldw_name: data.project_info.jldw_name,
								zbqy_name: data.project_info.zbqy_name,
								xm_address: data.project_info.xm_address
							});
							this.insuranceList = data.bx_list;
						}
					});
				}
			}
		},
		
		mounted() {
			this.request({
				url: '/project/select_list',
				data: {
					type: 3
				},
				success: data => {
					this.projectList = Array.from(data, item => {
						return {
							name: item.name,
							value: item.id
						}
					});
				}
			});
			
			if (this.id) {
				this.request({
					url: '/project/kgl/detail',
					data: {
						kgl_id: this.id
					},
					success: data => {
						this.$refs.form.set({
							kgl_id: this.id
						});
						this.$refs.form.set(data.kglInfo);
					}
				});
			} else {
				this.$refs.form.set(this.userInfo);
			}
		},
		
		methods: {
			submitHandle() {
				this.$refs.form.submit({
					url: this.id ? '/project/kgl/updateBase' : '/project/kgl/add',
					rule: {
						project_id: '请选择项目',
						yyzz_path: '请上传营业执照',
						frsfztx_path: '请上传法人身份证头像面',
						frsfzgh_path: '请上传法人身份证国徽面',
						zzzs_path: '请上传资质证书',
						sgfa_path: '请上传施工方案'
					},
					success: (data, res) => {
						this.$message({
							text: '提交成功'
						});
						this.navigateBack();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
